import { AxiosError } from "axios";

export interface ApiErrorDescription {
    title: string;
    message: string;
    details: string;
}

interface ProblemBody {
    status?: number;
    message?: string;
    traceId?: string;
}

const statusTitles: Record<number, string> = {
    400: "That request couldn't be completed",
    403: "You don't have access to that",
    409: "That conflicts with something that already exists",
    500: "Something went wrong on our side",
};

export function describeApiError(err: AxiosError): ApiErrorDescription {
    const status = err.response?.status;
    const body = err.response?.data as ProblemBody | string | undefined;
    const problem = typeof body == "object" && body != null ? body : undefined;

    const title = status ? statusTitles[status] ?? `Request failed (${status})` : "Couldn't reach Sorex";
    const message = problem?.message
        ?? (typeof body == "string" && body.length > 0 && body.length < 300 ? body : undefined)
        ?? (status ? "Try again in a moment. If it keeps happening, let us know." : "Check your connection and try again.");

    const details = [
        status ? `Status ${status}` : undefined,
        err.config?.method && err.config?.url ? `${err.config.method.toUpperCase()} ${err.config.url}` : undefined,
        problem?.traceId ? `Trace ${problem.traceId}` : undefined,
    ].filter(Boolean).join(" · ");

    return { title, message, details };
}
